import { useEffect } from "react";
import { FinishedContainer, HRImg, SquareImg, VRImg } from "./styles";
import { Container, Description, FlexContainer, Title } from "../../styles";
import { Wrapper } from "../Create/styles";
import Button from "../Button";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { DoneIcon, DownloadImages } from "../ImagesIcons";
import { LayoutsPreviewContainer } from "../Create/4-Preview/styles";
import Skeleton from "../../../../newUXComponents/Skeleton";
import { FormattedMessage } from "react-intl";
import { Image } from "antd";
import JSZip from "jszip";
import api from "../../../../service";
import generateHeaders from "../../../../utils/generateHeaders";
import { ResetCreatorAI } from "../../../../redux/modules/AI_Creator/actions";

export default function MediaKit() {
  const { unlimitedImages } = useSelector((state) => state.ai_creator);
  const history = useHistory();
  const { mediaKit, hasAccess, accessTrigger } = useSelector(
    (state) => state.ai_creator,
  );
  const { token } = useSelector((state) => state.auth);
  const { contract } = useSelector((state) => state.initialSettings);
  const dispatch = useDispatch();

  useEffect(() => {
    if (mediaKit.length === 0) history.push("/ai-creator");
  }, [history, mediaKit.length]);

  useEffect(() => {
    if (!hasAccess && accessTrigger) {
      dispatch(ResetCreatorAI());
      history.push("/checklist");
    }
  }, [hasAccess, dispatch, history, accessTrigger]);

  const handleDownload = async () => {
    const shapeTypes = ["square", "vertical", "horizontal"];
    const dimensions = ["1080x1350", "1080x1920", "1200x628"];

    try {
      const response = await api.get(
        `/media-kit/${contract.value}`,
        generateHeaders(token),
      );
      const { data } = response;
      const mediaKit = [
        data.imageSquareUrl,
        data.imageVerticalUrl,
        data.imageHorizontalUrl,
      ];

      const zip = new JSZip();

      await Promise.all(
        mediaKit.map(async (imageData, index) => {
          if (!imageData) return;

          let blob;
          if (imageData.startsWith("data:")) {
            const base64Data = imageData.split(",")[1];
            blob = await fetch(`data:image/png;base64,${base64Data}`).then(
              (res) => res.blob(),
            );
          } else {
            blob = await fetch(imageData).then((res) => res.blob());
          }

          zip.file(
            `mediakit_${shapeTypes[index]}_${dimensions[index]}.png`,
            blob,
          );
        }),
      );

      const zipBlob = await zip.generateAsync({ type: "blob" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(zipBlob);
      link.download = "mediakit_images.zip";
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading images:", error);
    }
  };

  return (
    <Container>
      <FinishedContainer>
        <Wrapper>
          <FlexContainer gap="10px">
            <DoneIcon />
            <Title marginBottom="0">
              <FormattedMessage id="ai_creator.media-kit" />
            </Title>
          </FlexContainer>
          <Description marginBottom="32px">
            <FormattedMessage id="ai_creator.media-kit.desc" />
          </Description>

          <LayoutsPreviewContainer>
            <Image.PreviewGroup>
              {mediaKit[0] && (
                <div>
                  <SquareImg
                    src={mediaKit[0]}
                    alt="Squared Layout"
                    preview={{
                      mask: <FormattedMessage id="ai_creator.image.preview" />,
                    }}
                    placeholder={
                      <Skeleton width={384} height={480} borderRadius={"0px"} />
                    }
                  />
                  <p>1080x1350</p>
                </div>
              )}

              {mediaKit[1] && (
                <div>
                  <VRImg
                    src={mediaKit[1]}
                    alt="Vertical Rectangle Layout"
                    preview={{
                      mask: <FormattedMessage id="ai_creator.image.preview" />,
                    }}
                    placeholder={
                      <Skeleton
                        width={270}
                        height={270 / 0.5625}
                        borderRadius={"0px"}
                      />
                    }
                  />
                  <p>1080x1920</p>
                </div>
              )}

              {mediaKit[2] && (
                <div>
                  <HRImg
                    src={mediaKit[2]}
                    alt="Horizontal Rectangle Layout"
                    preview={{
                      mask: <FormattedMessage id="ai_creator.image.preview" />,
                    }}
                    placeholder={
                      <Skeleton
                        width={614.4}
                        height={614.4 / (300 / 157)}
                        borderRadius={"0px"}
                      />
                    }
                  />
                  <p>1200x628</p>
                </div>
              )}
            </Image.PreviewGroup>
          </LayoutsPreviewContainer>

          <FlexContainer marginTop="32px" center>
            <Button
              label="download"
              theme="secondary"
              width="sm"
              icon={<DownloadImages />}
              onClick={handleDownload}
              iconPosition="start"
            />
            <Button
              label="ai_creator.media-kit.return"
              theme={unlimitedImages ? "secondary" : "primary"}
              width="sm"
              onClick={() => {
                history.push("/checklist");
              }}
            />
            {unlimitedImages && (
              <Button
                label="mediakit_generate_again"
                width="sm"
                onClick={() => {
                  history.push("/ai-creator/create");
                }}
              />
            )}
          </FlexContainer>
        </Wrapper>
      </FinishedContainer>
    </Container>
  );
}
